export default "__VITE_ASSET__CPv9aBYC__"